import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SessionSignalsStateService } from '../application/session/session-store.service';
import namedRoutes from './named-routes';

@Injectable({
  providedIn: 'root',
})
export class IsSignedInGuard implements CanActivate {
  private sessionStore = inject(SessionSignalsStateService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    if (this.sessionStore.select('isLogged')()) {
      return true;
    }

    return this.router.createUrlTree([namedRoutes.auth.signIn]);
  }
}
